// @flow
import React from "react";
import styles from "./menuBar.scss";

const closeBtnUrl = require("../../../assets/images/close_icn_white.svg");

type Props = {
  menuBarState: Object,
  toggleMenuBarDisplay: Function,
  navigateToRoute: Function
};

class MenuBar extends React.Component<Props> {
  renderSubRoutes(subRoutesArr: Array<any>) {
    const subRouteCells = subRoutesArr.map((subRouteObj, i) => (
      <div
        key={i}
        className={`${styles.subRouteCellWrapper} l-row a-center`}
        onClick={() => this.props.navigateToRoute(subRouteObj)}
      >
        {subRouteObj.title}
      </div>
    ));
    return <div className={`${styles.subRoutesWrapper}`}>{subRouteCells}</div>;
  }

  renderMainRoutes() {
    return this.props.menuBarState.columnWiseRoutes.map(
      (singleColumnRoutesArr, i) => {
        const columnCssClass = `column${i + 1}Wrapper`;
        return (
          <div
            key={i}
            className={`${styles.routesColumnWrapper} ${styles[columnCssClass]}`}
          >
            {singleColumnRoutesArr.map((routeObj, index) => (
              <div
                key={index}
                className={`${styles.routeCellWrapper} ${
                  routeObj.cellClassName ? styles[routeObj.cellClassName] : ""
                } l-col j-center  ${
                  routeObj.subRoutes && routeObj.subRoutes.length
                    ? styles.routeSubRouteCellWrapper
                    : ""
                } `}
              >
                <div className={`${styles.routeTitleWrapper} flex l-row`}>
                  {routeObj.icnFile && (
                    <div
                      className={`flex-30 l-row j-center ${styles.menuIcn} ${
                        routeObj.icnClassName
                          ? styles[routeObj.icnClassName]
                          : ""
                      }`}
                    >
                      <img src={routeObj.icnFile} alt="img" />
                    </div>
                  )}
                  <div
                    className={`${styles.routeTitle} flex-85 l-row a-center`}
                    onClick={() => this.props.navigateToRoute(routeObj)}
                  >
                    {routeObj.title}
                  </div>
                </div>

                {routeObj.subRoutes && routeObj.subRoutes.length
                  ? this.renderSubRoutes(routeObj.subRoutes)
                  : null}
              </div>
            ))}
          </div>
        );
      }
    );
  }
  render() {
    return (
      <div
        className={` l-col ${
          this.props.menuBarState.isMenuBarVisible
            ? styles.menuBarWrapper
            : styles.hiddenWrapper
        }  `}
      >
        <div className={`${styles.menuBarContainer} flex-auto`}>
          <div
            className={` ${styles.closeBtnWrapper} l-row a-center flex cursor-p`}
            onClick={() => this.props.toggleMenuBarDisplay(false)}
          >
            <img src={closeBtnUrl} alt="" />
            <div className={` ${styles.closeBtnLabel} l-row  j-center`}>
              CLOSE
            </div>
          </div>
          <div className={`${styles.routesWrapper} l-row`}>
            {this.renderMainRoutes()}
          </div>
        </div>
        <div
          className={`${styles.menuBarBackdrop} flex-auto`}
          onClick={() => this.props.toggleMenuBarDisplay(false)}
        />
      </div>
    );
  }
}

export default MenuBar;



// WEBPACK FOOTER //
// ./app/components/commons/menuBar/menuBar.js